import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const partnerList = async (params: object) => {
  return await GET({ url: Api.partnerList, params, showError: false })
}

export const jumpInfo = async (params: object) => {
  return await GET({ url: Api.jumpInfo, params, showError: false })
}
